import DateUtils from 'core/utils/date-utils';
import { TFunction } from 'i18next';
import moment from 'moment';
import { DeviceInfo, NpvrColumn, NpvrItem, RecordingsItem } from './types';

const allowedStatusToBeDeleted = ['scheduled', 'completed', 'partial', 'failed']

export default (data: any, t: TFunction): NpvrItem => {
  if (!data) {
    return {
      programId: '',
      program: '',
      recordings: []
    };
  }

  const recordings: RecordingsItem[] =
    data && data.recordings
      ? data.recordings.map((rec: any) => {
        return {
          assetId: rec?.assetId || t('general.not_available'),
          episodeName: rec?.episodeName || t('general.not_available'),
          channelName: rec?.channelName || t('general.not_available'),
          channelNumber: rec?.channelNumber || t('general.not_available'),
          startTime: rec && rec.startTime ? DateUtils.formatDate(rec.startTime) : t('general.not_available'),
          endTime: rec && rec.endTime ? DateUtils.formatDate(rec.endTime) : t('general.not_available'),
          actualStartTime:
            rec && rec.actualStartTime ? DateUtils.formatDate(rec.actualStartTime) : t('general.not_available'),
          actualEndTime: rec && rec.actualEndTime ? DateUtils.formatDate(rec.actualEndTime) : t('general.not_available'),
          duration:
            rec && rec.startTime && rec.endTime
              ? DateUtils.daysBetween(moment.utc(rec.startTime), moment.utc(rec.endTime))
              : t('general.not_available'),
          source: rec?.source || t('general.not_available'),
          timestamp: rec && rec.timestamp ? DateUtils.formatDate(rec.timestamp) : t('general.not_available'),
          status: rec?.status || t('general.not_available'),
        };
      })
      : [];
  return {
    programId: data ? data.programId : '',
    program: data && data.programName !== null ? data.programName : t('general.not_available'),
    recordings: recordings || []
  };
};

export const npvrColumns = (): Array<NpvrColumn> => [
  { name: 'dvr.column_asset_id', width: '10%', field: 'assetId' },
  { name: 'dvr.column_episode', width: '12%', field: 'episodeName' },
  { name: 'dvr.field_channel', width: '15%', field: 'channelName' },
  { name: 'dvr.column_channel_number', width: '15%', field: 'channelNumber' },
  { name: 'dvr.column_start_time', width: '15%', field: 'startTime' },
  { name: 'dvr.column_end_time', width: '15%', field: 'endTime' },
  { name: 'dvr.column_actual_start_time', width: '15%', field: 'actualStartTime' },
  { name: 'dvr.column_actual_end_time', width: '15%', field: 'actualEndTime' },
  { name: 'dvr.column_duration', width: '12%', field: 'duration' },
  { name: 'dvr.column_source', width: '10%', field: 'source' },
  { name: 'dvr.column_last_event', width: '15%', field: 'timestamp' },
  { name: 'dvr.column_status', width: '10%', field: 'status' },
  { name: '', width: '1%', field: '' }
];

export function deviceMapper(data: DeviceInfo[], t: TFunction) {
  const devices: DeviceInfo[] =
    data ? 
      data.map((device: DeviceInfo) => {
      return {
        udid: device?.udid || t('general.not_available'),
        createDate: device?.createDate ? DateUtils.formatDate(device.createDate) : t('general.not_available'),
        deviceFamily: device?.deviceFamily || t('general.not_available'),
        lastTechnicalDataEventDate: device?.lastTechnicalDataEventDate || t('general.not_available'),
      };
      }) : [];

  return devices
}